import { numberWithCommas } from "../helpers/app/numberFormater";
import {
  drawApprovalTable,
  drawDetailsTable,
  drawExpensesTable,
  drawFormHeader,
  formatPdfDate,
  renderSinglePageForm,
} from "../helpers/app/formPdf";

const generateAdvanceAccounatabilityFormPdf = (data, currency, expenditure) => {
  const money = (amount) =>
    `${currency === "D" ? "USD" : "UGX"} ${numberWithCommas(amount)}`;

  const doc = renderSinglePageForm((doc, layout) => {
    let y = drawFormHeader(doc, "AMANI INITIATIVE PAYMENT VOUCHER", layout);

    y = drawDetailsTable(
      doc,
      [
        ["Date:", formatPdfDate(data.created_at)],
        ["Advance Payment Voucher Number:", data.id],
        ["Project:", data.projectDetails?.project_name],
        ["Donor:", data.projectDetails?.donor_name],
        [
          "Funds Advance/Withdraw Form Number:",
          data.paymentVoucherDetails?.id,
        ],
        ["Requisition Form Number:", data.requisition_memo],
        ...(data.mode_of_payment
          ? [["Mode of Payment:", data.mode_of_payment]]
          : []),
        ["Budget Line:", data.budgetLineDetails?.name],
        ["Budget Code:", data.budgetLineDetails?.expense_code],
        ["Amount Advanced:", money(data.amountAdvanced)],
      ],
      y,
      layout
    );

    let advancedTotal = 0;
    let actualExpenditureTotal = 0;
    let varianceTotal = 0;
    const rows = (expenditure || []).map((activity) => {
      advancedTotal += activity.budgeted_amount || 0;
      actualExpenditureTotal += activity.actual_expenditure || 0;
      varianceTotal += activity.variance || 0;
      return [
        activity.item,
        money(activity.budgeted_amount),
        money(activity.actual_expenditure),
        money(activity.variance),
      ];
    });
    y = drawExpensesTable(
      doc,
      "Payment Voucher Expenditure",
      ["Item", "Amount Advanced", "Actual Expenditure", "Variance"],
      rows,
      [
        "Total",
        money(advancedTotal),
        money(actualExpenditureTotal),
        money(varianceTotal),
      ],
      y,
      layout
    );

    y = drawApprovalTable(
      doc,
      [
        { label: "Prepared", person: data?.creator, date: data.created_at },
        { label: "Checked", person: data?.checker, date: data.checked_at },
        { label: "Approved", person: data?.approver, date: data.approved_at },
      ],
      y,
      layout
    );

    return y;
  });
  doc.save(`AMANI INITIATIVE PAYMENT VOUCHER ${data.id || ""}`.trim());
};

export default generateAdvanceAccounatabilityFormPdf;
